import React, {useState} from 'react';
import FormContext from '../contexts/FormContext';

/**
 * Компонент обёртка. Предоставляет значение контекста CredentialsContext
 */
export default function Forms({ children }) {
  const [formG, setFormG] = useState();
  return <FormContext.Provider children={children} value={{formG: formG, setFormG: setFormG}} />
}